














import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { RatingIcon } from './icons';

@Component
export default class DefaultRating extends Vue {
  @Prop({ default: 1 })
  private step: number;

  @Prop({ required: true })
  private value: number;

  @Prop({ default: () => RatingIcon })
  private emptyIcon: Vue | string;

  @Prop({ default: () => RatingIcon })
  private filledIcon: Vue | string;

  private max = 5;

  private calculateFilledIconWidth(index: number): string {
    const indexValue = index * this.step;
    return indexValue > this.value
      ? `${ ((this.step - (indexValue - this.value)) * 100 / this.step).toPrecision(2) }%`
      : '100%';
  }
}
